import React from 'react';

interface Props {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  type?: 'submit' | 'button' | 'reset';
  disabled?: boolean;
  size: number;
  selected?: boolean;
  children?: React.ReactNode;
  testId?: string;
}

const CircleButton = ({
  onClick,
  disabled = false,
  selected,
  size,
  type = 'button',
  children,
  testId,
}: Props) => (
  <button
    className={`course-circle-button ${selected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
    style={{width: size, height: size}}
    type={type}
    tabIndex={-1}
    disabled={disabled}
    onClick={onClick}
    data-testid={`grade-picker-${testId}`}
  >
    {children}
  </button>
);

export default CircleButton;
